import type { DynamicClient } from '../../../client/types';
import { getWalletAccounts } from '../../wallets/getWalletAccounts';
import { findWaasWalletProviderByChain } from '../findWaasWalletProviderByChain';
import { isWaasWalletAccount } from '../isWaasWalletAccount';

export const restoreUserSharesForAllWalletAccounts = async (
  client: DynamicClient
) => {
  const walletAccounts = getWalletAccounts(client);

  const waasWalletAccounts = walletAccounts.filter((walletAccount) =>
    isWaasWalletAccount({ walletAccount })
  );

  await Promise.all(
    waasWalletAccounts.map(async (walletAccount) => {
      const provider = findWaasWalletProviderByChain(
        { chain: walletAccount.chain },
        client
      );

      /**
       * The environment might not have the embedded wallet extensions installed.
       * In that case there is no provider for the chain and we can skip restoring the user share.
       */
      if (!provider) return;

      return provider.restoreUserShareForWalletAccount({ walletAccount });
    })
  );
};
